import { cssTheme } from '@uds/theme-utils';
import { css } from 'linaria';

export default () => {
  return {
    title: css`
      color: ${cssTheme.palette.grey02};
    `,
    text: css`
      color: ${cssTheme.palette.grey04};
    `,
  };
};
